import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';

class SeUserSettingsService {
    constructor() {
        // noop
    }
    getSettings() {
        const storage = localStorage || {};
        try {
            if (!storage.userSettings) {
                storage.userSettings = '{}';
            }
            return JSON.parse(storage.userSettings);
        }
        catch (e) {
            console.error('Error parsing userSettings data', e, storage.userSettings);
            return {};
        }
    }
    setSettings(settings) {
        localStorage.userSettings = JSON.stringify(settings);
    }
    /**
     *
     * @param path The key of the object to get. This can be nested in the form of `level1.level2.level3...`
     * @returns any value if found. Use JSON.parse() to parse
     */
    get(path) {
        let obj = this.getSettings();
        const parts = path.split('.');
        while (obj && parts.length)
            obj = obj[parts.shift()];
        return obj;
    }
    /**
     *
     * @param path The key of the object to set. This can be nested in the form of `level1.level2.level3...`
     * @param val The value to set the found object to
     * @returns val parameter
     */
    set(path, val) {
        try {
            JSON.stringify(val);
        }
        catch (e) {
            throw new Error(`Cannot stringify value for storage: ${path}`);
        }
        const settings = this.getSettings();
        let obj = settings;
        const parts = path.split('.');
        const prop = parts.pop();
        while (parts.length) {
            const part = parts.shift();
            obj = obj[part] = obj[part] || {};
        }
        obj[prop] = val;
        this.setSettings(settings);
        return val;
    }
    /**
     *
     * @param path The key of the object to delete. This can be nested in the form of `level1.level2.level3...`
     * @returns boolean successful or not
     */
    remove(path) {
        const settings = this.getSettings();
        let obj = settings;
        const parts = path.split('.');
        const prop = parts.pop();
        while (obj && parts.length)
            obj = obj[parts.shift()];
        if (!obj || !(prop in obj))
            return false;
        delete obj[prop];
        this.setSettings(settings);
        return true;
    }
}
SeUserSettingsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeUserSettingsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SeUserSettingsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeUserSettingsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeUserSettingsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class SeUserSettingsModule {
}
SeUserSettingsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeUserSettingsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeUserSettingsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeUserSettingsModule });
SeUserSettingsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeUserSettingsModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeUserSettingsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    exports: []
                }]
        }] });

/*
 * Public API Surface of se-user-settings
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SeUserSettingsModule, SeUserSettingsService };
